import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, forwardRef, inject, Input, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { IProductDataV3 } from '@df/catalog/product/product';
import { GtmService } from '@df/module-gtm/gtm.service';
import { UiComponent } from '@df/ui/ui.component';
import { filter } from 'rxjs/operators';
import { BasketKlarnaContentBlockComponent } from '../../../../../basket/basket-klarna-content-block.component';
import { ExponeaStockNotificationComponent } from '../../../../../module/exponea/exponea-stock-notification.component';
import { PageSidebarComponent } from '../../../../../ui/display/page-sidebar/page-sidebar.component';
import { ProductDecorator } from '../../../../model/product/product.decorator';
import { ProductReviewsComponent } from '../../../review/product-reviews.component';
import { ProductDeliveryPriceComponent } from '../../delivery/price/product-delivery-price.component';
import { ProductGeneralDetailsComponent } from '../../details/product-general-details.component';
import { ProductGiftBoxingComponent } from '../../gift/boxing/product-gift-boxing.component';
import { HowToMeasureComponent } from '../../size-guide/how-to-measure-modal/how-to-measure.component';
import { ProductSizeGuideComponent } from '../../size-guide/product-size-guide.component';
import { IParentView } from '../layout/product-view-layout.abstract';
import { IProductViewLayoutContent } from '../layout/product-view-layout.interface';

@Component({
    selector: 'product-view-sidebar',
    templateUrl: './product-view-sidebar.component.html',
    standalone: true,
    imports: [
        BasketKlarnaContentBlockComponent,
        CommonModule,
        ExponeaStockNotificationComponent,
        HowToMeasureComponent,
        PageSidebarComponent,
        ProductDeliveryPriceComponent,
        ProductGeneralDetailsComponent,
        forwardRef(() => ProductGiftBoxingComponent),
        ProductReviewsComponent,
        ProductSizeGuideComponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductViewSidebarComponent extends UiComponent implements OnInit {
    @Input({ required: true })
    product!: ProductDecorator<IProductDataV3>;

    @Input({ required: true })
    parentView!: IParentView;

    @Input()
    parent!: ProductDecorator<IProductDataV3>;

    @Input()
    content!: IProductViewLayoutContent;

    protected router = inject(Router);
    private gtmService = inject(GtmService);

    override ngOnInit(): void {
        super.ngOnInit();

        this.subscriptions.add(
            this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
                this.parentView.isSidebarOpen = false;
                this.detectChanges();
            })
        );

        this.subscriptions.add(this.parentView.detectChanges$.subscribe(() => this.detectChanges()));
    }

    handleIsOpenChange(_isOpen: boolean): void {
        this.parentView.detectChanges$.next();
    }

    handleCloseRequest(): void {
        if (this.parentView.sidebar === 'how-to-measure') {
            this.parentView.sidebar = 'size-guide';
            this.detectChanges();
        } else {
            this.parentView.isSidebarOpen = false;
            this.sendGtmEvent('close' + this.parentView.sidebar.charAt(0).toUpperCase() + this.parentView.sidebar.slice(1));
        }
    }

    private sendGtmEvent(event: string): void {
        this.gtmService.push({ event });
    }
}
